/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {ServiceModel} from '../../../../model'
import {getService} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useTableMaster} from '../../../../hooks'
const TableService: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    setUpdateTable,
    setClearTable,
    clearTable,
    selectedOn,
    updateTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const {typeClothe, getTypeClotheList} = useTableMaster()

  const getClientList = async () => {
    setLoading(true)
    const response = await getService(searchValues, pagination.currentPage)
    setData(response.data.data)
    setPagination({
      ...pagination,
      totalResults: response.data.total,
    })
    setLoading(false)
  }

  useEffect(() => {
    getTypeClotheList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getClientList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getClientList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-service',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<ServiceModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Código de servicio' name='codigo' searcheable />
        ),
        accessor: 'codigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Descripción de servicio'
            name='descripcion'
            searcheable
          />
        ),
        accessor: 'descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de ropa'
            name='tipoRopaId'
            data={typeClothe}
            selecteable
          />
        ),
        accessor: 'tipoRopaNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Administrador de servicio'
            name='tipoAdministracion'
            searcheable
          />
        ),
        accessor: 'tipoAdministracion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Orden'
            name='tipoOrdenLavadoNombre'
            searcheable
          />
        ),
        accessor: 'tipoOrdenLavadoNombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado' name='estadoServicio' />,
        accessor: 'estadoServicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [typeClothe, selectedOn],
  )

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableServiceWrapper = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <TableService />
      </div>
    </KTableProvider>
  )
}

export {TableServiceWrapper}
